"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bookHealthPackageApi = bookHealthPackageApi;
exports.bookPackage = bookPackage;
exports.cancelPackage = cancelPackage;
exports.getAllActivePackages = getAllActivePackages;
exports.getBookedPackageDetails = getBookedPackageDetails;
exports.getBookedPackageList = getBookedPackageList;
exports.getCmsPackageList = getCmsPackageList;
exports.getFacilityPackage = getFacilityPackage;
exports.getPackageAmountList = getPackageAmountList;
exports.getPackageClinicList = getPackageClinicList;
exports.getPackageDetails = getPackageDetails;
exports.getPackageList = getPackageList;
exports.getRelatedPackages = getRelatedPackages;
exports.getStaticContent = getStaticContent;
var _genericFetch = _interopRequireWildcard(require("../../../common/api/genericFetch"));
var _ApiConst = require("../../../common/utils/ApiConst");
var _utils = require("../../../common/utils/utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function getFacilityPackage(params, tokenData) {
  const queryString = (0, _utils.getQuery)(params);
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.HEALTH_PACKAGES}/facilityPackages${queryString}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function getPackageList(params, tokenData) {
  const queryString = (0, _utils.getQuery)(params);
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.HEALTH_PACKAGES}/packageList${queryString}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function getPackageDetails(params, tokenData) {
  const queryString = (0, _utils.getQuery)(params);
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.HEALTH_PACKAGES}/packageDetails${queryString}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function getPackageClinicList(params, tokenData) {
  const queryString = (0, _utils.getQuery)(params);
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.HEALTH_PACKAGES}/packageFacilities${queryString}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function getBookedPackageList(params, tokenData) {
  const queryString = (0, _utils.getQuery)(params);
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.HEALTH_PACKAGES}/allPackages${queryString}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function getBookedPackageDetails(params, tokenData) {
  const queryString = (0, _utils.getQuery)(params);
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.HEALTH_PACKAGES}/package${queryString}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function getPackageAmountList(params, tokenData) {
  const queryString = (0, _utils.getQuery)(params);
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.HEALTH_PACKAGES}/amountsBypackageIds${queryString}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function cancelPackage(params, tokenData) {
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.CANCEL_HEALTH_PACKAGE}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = params;
  options.method = _ApiConst.API_PARAMS.PUT;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function getCmsPackageList(params, tokenData) {
  const queryString = (0, _utils.getQuery)(params);
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.HEALTH_PACKAGES}/packagesByIds${queryString}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function bookHealthPackageApi(params, tokenData) {
  let queryString = '?';
  for (const key in params) {
    if (queryString === '?') {
      queryString = queryString + key + '=' + params[key];
    } else {
      queryString = queryString + '&' + key + '=' + params[key];
    }
  }
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.HEALTH_PACKAGES}/bookPackage`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = params;
  options.method = _ApiConst.API_PARAMS.POST;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function bookPackage(params, tokenData) {
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.BOOK_HEALTH_PACKAGE}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = params;
  options.method = _ApiConst.API_PARAMS.POST;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function getStaticContent(params, tokenData) {
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.PACKAGE_STATIC_CONTENT}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function getRelatedPackages(params, tokenData) {
  const queryString = (0, _utils.getQuery)(params);
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.RELATED_PACKAGES}${queryString}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function getAllActivePackages(params, tokenData) {
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.ALL_ACTIVE_PACKAGES}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}